import Dialog from "@components/dialog";
import styled from "styled-components";

import { T_PLAIN_small } from "../../../global.style";

export const GroupTileItemBackground = styled.div`
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
    position: relative;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    margin-right: 6px;
    margin-bottom: 6px;
    
    padding-top: 0;
    
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const GroupTileBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    cursor: pointer;
`;

export const DialogTileWrapper = styled.div `
    margin-bottom: 32px;
    margin-right: 32px;
    width: 125px;
    height: 125px;
`;

export const GroupTileItems = styled.div`
    display: flex;
    padding: 0 4px 4px 11px;
    flex-wrap: wrap;
`;
export const GroupTileTitle = styled.span`
    ${T_PLAIN_small};
    pointer-events: none;
    font-weight: bold;
`;

export const GroupDialogTileTitle = styled.div `
    ${T_PLAIN_small};
    pointer-events: none;
    font-weight: bold;
    margin-top: 6px;
`;

export const GroupTileDialogBody = styled.div<{isSmall?: boolean}>`
    width: ${props => props.isSmall ? "358px" : "515px"};
    height: ${props => props.isSmall ? "358px" : "515px"};
    border-radius: 68px;
    box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.25);
    background-color: ${props => props.theme.C_BG_floorplan };
`;

export const GroupTileDialogItems = styled.div `
    display: flex;
    flex-wrap: wrap;
    padding: 38px 0 5px 38px;
    height: auto;
`;

export const DialogTile = styled(Dialog) `
    border-radius: 68px;
`;